export default __webpack_public_path__ + "static/Entenda0082-e1cf3769d4d0030366da68ea3672c1a1.jpg";